export class FileConstants {
    static FILE_DOWNLOAD = "File download";
    static HEAD_ERROR = "Server did not return Content-Length. Chunking impossible.";
}
